module.exports = "../images/fishing-lodge-3-20.jpg?v=ccbeb52";